import React from 'react';
import Link from '@material-ui/core/Link';
import Grid from '@material-ui/core/Grid';
import ErrorOutlinedIcon from '@material-ui/icons/ErrorOutlined';
import CheckCircleOutlineOutlinedIcon from '@material-ui/icons/CheckCircleOutlineOutlined';

import { TestValue } from './util/types';

import { getDeepLink } from './util/links';

type TrendProps = { testValue: TestValue; count: number };
export function Trend({ testValue, count }: TrendProps): React.ReactElement {
  const lastN = testValue.results.slice(0, count);
  lastN.reverse();
  return (
    <Grid item>
      {lastN.map((result, i) => {
        const deepLink = getDeepLink(result);
        const startedAtTrimmed = result.startedAt.replace(/:\d+\..*/g, '');
        const tooltip = `${startedAtTrimmed} - ${result.buildCommit.slice(
          0,
          8,
        )}`;
        let statusIcon = <CheckCircleOutlineOutlinedIcon color="action" />;
        if (result.status === 'failed') {
          statusIcon = <ErrorOutlinedIcon color="error" />;
        }
        return (
          <Link href={deepLink} title={tooltip} key={i}>
            {statusIcon}
          </Link>
        );
      })}
    </Grid>
  );
}
